import React, { useState } from 'react';
import { Modal, Radio } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CustomModal = styled(Modal)`
  width: 500px;
`;

function ModalSelecionarTabExcel({ onOkClick, onCancelClick, sheetNames = [] }) {
  const [selectedSheet, setSelectedSheet] = useState();

  return (
    <CustomModal
      title="Selecione a planilha desejada"
      onOk={() => onOkClick(selectedSheet)}
      okButtonProps={{ disabled: !(selectedSheet >= 0) }}
      okText="Continuar importação"
      cancelText="Cancelar"
      visible
      onCancel={onCancelClick}
    >
      <p>O documento possui mais de uma planilha. Por favor, selecione a planilha desejada:</p>
      <Radio.Group
        buttonStyle="solid"
        onChange={(e) => setSelectedSheet(e.target.value)}
        value={selectedSheet}
      >
        {sheetNames.map((sheetName, index) => (
          <Radio
            key={sheetName}
            value={index}
          >
            {sheetName}
          </Radio>
        ))}
      </Radio.Group>
    </CustomModal>
  );
}

ModalSelecionarTabExcel.propTypes = {
  onOkClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  sheetNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ModalSelecionarTabExcel;
